import type { DevicePermission } from './types';

/**
 * Builds the iframe `allow` attribute from device permissions.
 * Format: "camera *; microphone https://example.com; geolocation 'self'"
 *
 * @param devicePermissions - Array of device permissions
 * @returns The allow attribute string or undefined if no permissions
 */
export const buildAllowAttribute = (devicePermissions?: DevicePermission[]): string | undefined => {
    if (!devicePermissions?.length) {
        return undefined;
    }

    const permissions = devicePermissions
        .filter((p) => p.type)
        .map((p) => (p.value?.trim() ? `${p.type} ${p.value.trim()}` : p.type!));

    return permissions.length ? permissions.join('; ') : undefined;
};

/**
 * Builds the iframe `sandbox` attribute from sandbox permissions.
 * Format: "allow-scripts allow-same-origin allow-forms"
 *
 * @param sandboxPermissions - Array of sandbox permission strings
 * @returns The sandbox attribute string or undefined if no permissions
 */
export const buildSandboxAttribute = (sandboxPermissions?: string[]): string | undefined => {
    if (!sandboxPermissions?.length) {
        return undefined;
    }

    return sandboxPermissions.join(' ');
};
